import React from "react";
import classnames from "classnames";

import GiftVouchers from "./gift-vouchers";
import RegularVouchers from "./regular-vouchers.js";
import {useStoreCartVouchers} from "./use-store-cart-vouchers";

const VouchersForms = () => {
	const {getFormType} = useStoreCartVouchers();

	if (getFormType() === 'gift') {
		return (
			<GiftVouchers />
		);
	} else {
		return (
			<div className={classnames(
				"wp-block-woocommerce-cart-order-summary-subtotal-block",
				"wc-block-components-totals-wrapper"
			)}>
				<RegularVouchers />
			</div>
		);
	}
}

export default VouchersForms;
